/**
 * AuthLayout — full-bleed brand background for the auth screens (#601 W1,
 * brief 01). Ported from the design-pack login screen container
 * (NU-DATA-DASHBOARD/kits/nu-data/components/screens/login.jsx): the
 * `.nu-login-bg` treatment (dashboard-bg.jpg + theme-aware gradient scrim,
 * defined in src/styles/nu/nu-brand.css) with the auth card grid-centered.
 * Mechanics are unchanged: it wraps children and centers them; the login
 * route stays outside the shell chrome.
 */

import React from "react";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div
      className="nu-login-bg"
      style={{
        position: "fixed",
        inset: 0,
        display: "grid",
        placeItems: "center",
        padding: 24,
        overflowY: "auto",
      }}
    >
      {children}
    </div>
  );
};

export default AuthLayout;
